"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var ExpRE = /^\s*\{\{(.*)\}\}\s*$/;
var actionsSymbol = Symbol.for("__REVA_ACTIONS");
exports.complieExpression = function (source, context, exclude) {
    var seenObjects = [];
    var complie = function (source) {
        if (shared_1.isStr(source)) {
            var matched = source.match(ExpRE);
            if (!matched)
                return source;
            var vars = Object.keys(context || {});
            var params = vars.map(function (key) { return context[key]; });
            return new (Function.bind.apply(Function, __spreadArrays([void 0], vars, ["return (" + matched[1] + ");"])))().apply(void 0, params);
        }
        else if (shared_1.isArr(source)) {
            return source.map(function (value) { return complie(value); });
        }
        else if (shared_1.isPlainObj(source)) {
            if (source[actionsSymbol]) {
                return source;
            }
            if (source['_isAMomentObject']) {
                return source;
            }
            if (source['_isJSONSchemaObject']) {
                return source;
            }
            if (shared_1.BigData.isBigData(source)) {
                return source;
            }
            if (shared_1.isFn(source['toJS'])) {
                return source;
            }
            if (shared_1.isFn(source['toJSON'])) {
                return source;
            }
            if (seenObjects.includes(source)) {
                return source;
            }
            seenObjects.push(source);
            return shared_1.reduce(source, function (buf, value, key) {
                if (shared_1.isFn(exclude)) {
                    if (exclude(key, value)) {
                        buf[key] = value;
                        return buf;
                    }
                }
                if (key == 'x-linkages') {
                    buf[key] = value;
                    return buf;
                }
                if (value && value['_owner'] && value['$$typeof']) {
                    buf[key] = value;
                    return buf;
                }
                buf[key] = complie(value);
                return buf;
            }, {});
        }
        return source;
    };
    return complie(source);
};
